import Nullstack from 'nullstack';
export default function IconToolsKitchenOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tools-kitchen-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 3h5l-.5 4.5m-.4 3.595l-.1 .905h-6l-.875 -7.874"
  }), "   ", Nullstack.element("path", {
    d: "M7 18h2v3h-2z"
  }), "   ", Nullstack.element("path", {
    d: "M15.225 11.216c.42 -2.518 1.589 -5.177 4.775 -8.216v12h-1"
  }), "   ", Nullstack.element("path", {
    d: "M20 15v1m0 4v1h-1v-2"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v6"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}